export default {
  tappedDuration: 1,
  held: [],
  sequence: [],
  lastTapped: null,
  sequenceCleared: false,
  resetKeys: [],
  bannedKeys: ['Tab']
}